<template>
  <div class="formulate-input">
    <div class="formulate-input-wrapper">
      <label class="formulate-input-label">{{ field.label }}</label>
    </div>
    <b-button
      v-for="option in field.options"
      v-model="computedOptions"
      :key="option.key"
      class="me-2"
      pill
      :variant="computedOptions === option.value ? '' : 'outline-secondary'"
      @click="onChangeOptions(option.value)"
    >
      {{ option.label }}
    </b-button>
  </div>
</template>

<script>
export default {
  props: {
    value: null,
    field: {
      type: Object,
      required: true
    }
  },
  emits: ['input'],
  computed: {
    computedOptions: {
      get: function () {
        return this.value
      },
      set: function (newValue) {       
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    onChangeOptions(val) {
      this.computedOptions = val
    }
  },
}
</script>